import React from 'react';

interface NotAvailableProps {
  className?: string;
}

// Marks a value we have no real data for yet, so the gaps are easy to spot.
// Search for <NotAvailable to find every place that still needs data.
const NotAvailable: React.FC<NotAvailableProps> = ({ className = '' }) => (
  <span className={`font-['Open_Sans'] italic text-[#767472] ${className}`.trim()}>
    Not available
  </span>
);

export default NotAvailable;
